/**
 * Unbridaled cart sync.
 *
 * The Unbridaled widget performs its own POST /cart/add.js (doAddToCart) when
 * the customer builds a ring, bypassing the theme's product-form flow — so the
 * cart drawer and header cart counts never re-render (stale until a manual
 * reload). The widget dispatches no public "added to cart" event, so we detect
 * its cart adds at the network layer instead: any successful cart add whose
 * request did NOT ask for `sections` (the theme's own product-form always
 * does) triggers a Section Rendering API refresh of the drawer + cart icons,
 * then opens the drawer.
 *
 * Loaded only on Unbridaled PDPs (see product-details.liquid).
 */
(function () {
  let scheduled = null;

  function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return;

    const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);

    fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
      .then((response) => response.json())
      .then((sections) => {
        cartDrawer.renderContents({ sections });
      })
      .catch((error) => console.error('[unbridaled-cart-sync] drawer refresh failed', error));
  }

  // The widget may add several items back-to-back (diamond, then the ring via
  // its re-click hand-off) — collapse them into a single refresh.
  function scheduleRefresh() {
    clearTimeout(scheduled);
    scheduled = setTimeout(refreshCartDrawer, 600);
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url);
  }

  // The theme's own product-form.js requests `sections` with the add and
  // renders the drawer itself — only refresh for adds that skip that flow.
  function requestsSections(body) {
    return typeof body === 'string' && body.includes('"sections"');
  }

  // Unbridaled's doAddToCart uses fetch(). Do not read the response body here:
  // the widget consumes it (response.json()) and a second read would throw.
  const originalFetch = window.fetch;
  window.fetch = function (resource, options) {
    const url = typeof resource === 'string' ? resource : resource && resource.url;
    const promise = originalFetch.apply(this, arguments);
    if (isCartAddUrl(url) && !(options && requestsSections(options.body))) {
      promise.then((response) => {
        if (response.ok) scheduleRefresh();
      }).catch(() => {});
    }
    return promise;
  };

  // Cover XMLHttpRequest too in case the widget's HTTP client changes.
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._ubCartAdd = String(method).toUpperCase() === 'POST' && isCartAddUrl(url);
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._ubCartAdd && !requestsSections(body)) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) scheduleRefresh();
      });
    }
    return originalSend.apply(this, arguments);
  };
})();
